export const PrevIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="12"
    fill="none"
    viewBox="0 0 8 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.321 6.372a1 1 0 0 1 0-1.468L5.335.266a1 1 0 0 1 1.358 0l.04.038a1 1 0 0 1 0 1.468L2.555 5.638l4.18 3.866a1 1 0 0 1 0 1.468l-.041.038a1 1 0 0 1-1.358 0L.32 6.372Z"
    />
  </svg>
);

export const NextIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="12"
    fill="none"
    viewBox="0 0 8 12"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.734 4.904a1 1 0 0 1 0 1.468L1.72 11.01a1 1 0 0 1-1.358 0l-.041-.038a1 1 0 0 1 0-1.468l4.18-3.866L.32 1.772a1 1 0 0 1 0-1.468L.36.266a1 1 0 0 1 1.359 0l5.014 4.638Z"
    />
  </svg>
);

export const VideoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_2813_21199)">
      <path
        d="M1.7771 4.88854C1.7771 4.0634 2.10488 3.27205 2.68835 2.68859C3.27181 2.10513 4.06315 1.77734 4.88829 1.77734H11.1107C11.9358 1.77734 12.7272 2.10513 13.3106 2.68859C13.8941 3.27205 14.2219 4.0634 14.2219 4.88854V11.1109C14.2219 11.9361 13.8941 12.7274 13.3106 13.3109C12.7272 13.8943 11.9358 14.2221 11.1107 14.2221H4.88829C4.06315 14.2221 3.27181 13.8943 2.68835 13.3109C2.10488 12.7274 1.7771 11.9361 1.7771 11.1109V4.88854Z"
        stroke="currentColor"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.05566 5.70474C6.74097 5.50806 6.33276 5.7343 6.33276 6.10541V9.89376C6.33276 10.2649 6.74097 10.4911 7.05566 10.2944L10.0863 8.40025C10.3824 8.21519 10.3824 7.78397 10.0863 7.59892L7.05566 5.70474Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2813_21199">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
